<template>
	<div class="mt-2 w-full">
		<SoftSwitch v-model="showInfoSync" :label="$t('dashboard.vibEventSummary.showInfo')" />
		<SoftSwitch v-model="showDataSync" :label="$t('dashboard.vibEventSummary.showData')" />
		<SoftSwitch
			v-model="showOverpressureSync"
			:label="$t('dashboard.vibEventSummary.showOverpressure')"
		/>
	</div>
</template>

<script lang="ts">
import { useModelValue, useRefObjectSync } from "@soft-db/soft-utils";
import { defineComponent, PropType } from "vue";
import {
	defaultVibrationEventSummaryOptions,
	VibrationEventSummaryOptions,
} from "./vibration-event-summary-options";

export default defineComponent({
	name: "VibrationEventSummaryPluginConfig",
	props: {
		modelValue: {
			type: Object as PropType<VibrationEventSummaryOptions>,
			default: () => defaultVibrationEventSummaryOptions,
		},
	},
	setup(props) {
		const valueModel = useModelValue(props);

		const showInfoSync = useRefObjectSync(valueModel, "showEventInfo");
		const showDataSync = useRefObjectSync(valueModel, "showEventData");
		const showOverpressureSync = useRefObjectSync(valueModel, "showEventOverpressure");

		return { showInfoSync, showDataSync, showOverpressureSync };
	},
});
</script>
